<app-dialog-base data-testid="failed-autoplay-details-dialog">
  <span dialog-title>Failed Autoplay Strip Details</span>

  <ng-container dialog-content>
    <div>
      <div class="margin-top-med">
        <div class="bold-text">Strip ID</div>
        <div data-testid="failed-autoplay-strip-id">{{ data.strip.Id }}</div>
      </div>

      <div class="margin-top-med">
        <div class="bold-text">Ticket Numbers</div>
        <div data-testid="failed-autoplay-ticket-numbers">{{ data.strip.TicketNumbers }}</div>
      </div>

      <div class="margin-top-med">
        <div class="bold-text">Payment Tier</div>
        <div data-testid="failed-autoplay-payment-tier">{{ data.strip.PaymentTierString }}</div>
      </div>

      @if (errorMessages.length > 0) {
        <div class="margin-top-med">
          <div class="bold-text">Error Messages</div>
          <div class="error-messages" data-testid="failed-autoplay-error-messages">
            @for (error of errorMessages; track error) {
              <div class="error-message">{{ error }}</div>
            }
          </div>
        </div>
      }

      <div class="margin-top-med meta-data">
        <div class="bold-text">Full Details</div>
        @if (metaData) {
          <pre data-testid="failed-autoplay-failure-details"><app-formatter [data]="metaData"></app-formatter></pre>
        }
      </div>
    </div>

  </ng-container>
  <ng-container actions></ng-container>
</app-dialog-base>
